<template>
  <section class="container how-to-get-there" aria-label="how to get there">
    <h2>How to Get There</h2>
    <div class="col">
      <div class="row">
        <div class="how--svg">
          <img
            src="/images/areas/car.svg"
            class="how--car"
            alt="Outline drawing of a car."
            role="presentation"
          />
        </div>
        <div class="text-left">{{ travelOptions.car }}</div>
      </div>
      <div class="row" v-if="travelOptions.airplane">
        <div class="how--svg">
          <img
            src="/images/areas/airplane.svg"
            class="how--plane"
            alt="Outline drawing of an airplane."
            role="presentation"
          />
        </div>
        <div class="text-left">{{ travelOptions.airplane }}</div>
      </div>
      <div class="row" v-if="travelOptions.bus">
        <div class="how--svg">
          <img
            src="/images/areas/bus.svg"
            class="how--bus"
            alt="Outline drawing of a bus."
            role="presentation"
          />
        </div>
        <div class="text-left">{{ travelOptions.bus }}</div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'travel-options',
  components: {},
  props: {
    travelOptions: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.row {
  flex-wrap: nowrap !important;
  gap: 1rem;
  max-width: 38rem;
  margin: 3rem auto;
}
.how-to-get-there {
  margin-bottom: 5rem;
  margin-top: 5rem;
}
.how--svg {
  margin-bottom: 30px;
  background-color: #d1d7da;
  border-radius: 100%;
  min-width: 64px;
  height: 64px;
  position: relative;
}
.how--bus {
  position: absolute;
  z-index: 10;
  top: 30%;
  bottom: 50%;
  left: 30%;
  right: 50%;
  height: 26px;
  color: #173945;
}
.how--plane {
  position: absolute;
  z-index: 10;
  top: 30%;
  bottom: 50%;
  left: 20%;
  right: 50%;
  height: 22px;
  color: #173945;
}
.how--car {
  position: absolute;
  z-index: 10;
  top: 35%;
  bottom: 50%;
  left: 25%;
  right: 50%;
  height: 18px;
  color: #173945;
}
.text-left {
  font-size: 1rem;
}
</style>
